import React, { useState, useEffect } from "react";
import "./Contact.css";
import toast, { Toaster } from "react-hot-toast";
import Item from "./Item";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const Contact = () => {
  const [role, setRole] = useState("");
  const [formData, setFormData] = useState({
    sender_name: "",
    sender_email: "",
    subject: "",
    message: "",
    feedback_type: "query",
  });

  useEffect(() => {
    const userRole = secureLocalStorage.getItem("role");
    setRole(userRole);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validation for name, subject, and message fields (accept only strings)
    if (name === "sender_name" || name === "subject" || name === "message") {
      // Check if the value contains only letters and spaces
      if (/^[A-Za-z\s]+$/.test(value) || value === "") {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (
      !formData.sender_email ||
      !formData.sender_name ||
      !formData.subject ||
      !formData.message
    ) {
      toast.error("Please fill in all required fields", {
        duration: 3000,
        style: {
          fontSize: "20px",
          borderRadius: "10px",
          background: "var(--color-white-50)",
          color: "#fff",
        },
      });
      return;
    }

    try {
      // Make a POST request to the backend endpoint
      const response = await axios.post(
        "http://127.0.0.1:8000/feedback/create-query",
        formData
      );
      // Handle response based on server's response
      if (response.status === 200) {
        toast.success("Query sent successfully!!", {
          duration: 3000,
          style: {
            fontSize: "20px",
            borderRadius: "10px",
            background: "var(--color-white-50)",
            color: "#fff",
          },
        });
        setFormData({
          sender_email: "",
          sender_name: "",
          subject: "",
          message: "",
        });
      } else {
        toast.error("Unable to send Query", {
          duration: 3000,
          style: {
            fontSize: "20px",
            borderRadius: "10px",
            background: "var(--color-white-50)",
            color: "#fff",
          },
        });
      }
    } catch (error) {
      toast.error("Please provide valid email!!", {
        duration: 3000,
        style: {
          fontSize: "20px",
          borderRadius: "10px",
          background: "var(--color-white-50)",
          color: "#fff",
        },
      });
    }
  };
  return (
    <>
      {role == "admin" ? null : (
        <section id="contact" className="frame-root1">
          <div className="divrow3">
            <div className="divcol-lg-62">
              <div className="contact-information-parent">
                <h1 className="contact-information">Contact Information</h1>
                <div className="want-more-information-container">
                  <p className="want-more-information">
                    Want more information about Forex Miner?
                  </p>
                  <p className="email-us-right">Email us right now.</p>
                </div>
              </div>
              <div className="frame-a-p-i">
                <Item
                  heading4SecurityMeasures="Provide full name as"
                  muhammadAbdullah="Muhammad Abdullah"
                />
                <Item
                  heading4SecurityMeasures="Sample email"
                  muhammadAbdullah="demo@gmail.com"
                  propTop="-0.25rem"
                />
                <div className="item24">
                  <div className="divicon-parent">
                    <div className="divicon7">
                      <div className="security-icon-frame1">
                        <div className="circle" />
                      </div>
                    </div>
                    <div className="heading-44">
                      Provide numbering to multiple questions as
                    </div>
                  </div>
                  <div className="question-frame">
                    <div className="question1-question2">
                      <ol className="question1-question21">
                        <li className="question1">Question1...</li>
                        <li>Question2...</li>
                      </ol>
                    </div>
                  </div>
                </div>
                <div className="item25">
                  <div className="divicon7">
                    <div className="security-icon-frame1">
                      <div className="circle" />
                    </div>
                  </div>
                  <div className="heading-45">
                    Make sure you provide subject before sending message
                  </div>
                </div>
              </div>
            </div>
            <div className="divcol-lg-63">
              <div className="footer-quick-links">
                <div className="form">
                  <div className="title">
                    <h3 className="contact-us">Contact Us</h3>
                  </div>
                  <div className="item26">
                    <div className="name">Name</div>
                    <input
                      name="sender_name"
                      value={formData.sender_name}
                      onChange={handleChange}
                      className="input"
                      placeholder="Enter Your Email Address"
                      type="text"
                    />
                  </div>
                  <div className="item26">
                    <div className="name">Email</div>
                    <input
                      name="sender_email"
                      value={formData.sender_email}
                      onChange={handleChange}
                      className="input"
                      placeholder="Enter Your Email Address"
                      type="text"
                    />
                  </div>
                  <div className="item26">
                    <div className="name">Subject</div>
                    <input
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      className="input"
                      placeholder="Enter Your Email Address"
                      type="text"
                    />
                  </div>
                  <div className="item26">
                    <div className="name">Message</div>
                    <input
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      className="input"
                      placeholder="Enter Your Email Address"
                      type="text"
                    />
                  </div>
                  <div className="item30">
                    <button className="link5" onClick={handleSendMessage}>
                      <b className="send-message">Send Message</b>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Toaster />
        </section>
      )}
    </>
  );
};

export default Contact;
